import { required, requiredIf } from 'vuelidate/lib/validators';

const landlordSelections = [
  'the Fund requires cash flow to meet pension or other benefit payments',
  'the Fund has ongoing commitments to meet loan repayments',
  'a number of fund expenses will continue to be incurred despite any rent relief offered to the Tenant',
  'other',
];

const mStep = {
  title: 'Landlord',
  // eslint-disable-next-line max-len
  description: 'The Code encourages the tenant and landlord to negotiate in good faith, taking into account the needs of, and impact of Covid-19 on, both parties. This may include providing less generous rent relief than envisaged under the Code as a result of the particular circumstances of the landlord.',
};

export default {
  name: 'rent-relief-landlord',
  data: () => ({
    landlordSelections,
    mStep,
  }),
  computed: {
    landlordSelection: {
      get() {
        return this.$store.getters['toolkit/getItemData'].adjustments.landlord.landlord;
      },
      set(value) {
        if (value.includes('other')) {
          this.$store.dispatch('toolkit/updateItemKey',
            { data: { adjustments: { landlord: { landlord: value } } } });
        } else {
          this.$store.dispatch('toolkit/updateItemKey',
            { data: { adjustments: { landlord: { landlord: value, other: '' } } } });
        }
      },
    },
    other: {
      get() {
        return this.$store.getters['toolkit/getItemData'].adjustments.landlord.other;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey',
          { data: { adjustments: { landlord: { other: value } } } });
      },
    },
    hasLandlord: {
      get() {
        return this.$store.getters['toolkit/getItemData'].adjustments.landlord.hasLandlord;
      },
      set(value) {
        const adjustments = {
          adjustments: {
            landlord: {
              hasLandlord: (value === 'true'),
              landlord: [],
              other: '',
            },
          },
        };
        this.$store.dispatch('toolkit/updateItemKey', { data: adjustments });
      },
    },

  },
  methods: {
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },

  },
  validations: {
    hasLandlord: {
      required,
    },
    other:
      {
        required: requiredIf(function otherRequired() {
          if (this.landlordSelection.findIndex(value => value === 'other') >= 0) {
            return true;
          }
          return false;
        }),
      },
    landlordSelection: {
      required: requiredIf(function landlordSelectionRequired() {
        return this.hasLandlord;
      }),
    },
  },
};
